@use '../../../../styles/Constants.scss' as Constants;
@use '../../../../styles/Colors.scss' as Colors;

$filter-date-min-width: 150px;

@mixin option {
	margin-right: Constants.$val-spacing-s;
	display: flex;
	min-width: $filter-date-min-width;
	margin-left: auto;
}

.main-filter {
	display: flex;
	flex-direction: row;
	align-items: center;
	border-radius: Constants.$val-borderRadius;
	background-color: Colors.$col-design-blue500;
	height: Constants.$val-inputHeight;
	
	&__selected {
		color: Colors.$col-white;
		display: flex;
		align-items: center;
	}

	& :global(.dropdown-toggle) {
		padding: 0 Constants.$val-spacing-xs 0 6px;
		min-width: 120px;
	}

	& :global(.dropdown-item) {
		// Matching the width of parent dropdown, which also has fixed width
		min-width: 130px;
	}
}